import React from 'react';
import './PlaylistHeader.styl';
import {ReactComponent as Minimize} from 'images/playlist/minimize.svg';
import {ReactComponent as Maximize} from 'images/playlist/maximize.svg';
import {ReactComponent as Close} from 'images/playlist/largeX.svg';
import {PLAYLIST_VISIBILITY} from 'stores/CoachingPlaylistStore';
import './PlaylistTitleBar.styl';

interface Props {
  title: string;
  closable: boolean;
  onHide?: () => void;
  onToggle: () => void;
  visibility: string;
}

const PlaylistTitleBar: React.FC<Props> = ({title, closable, onHide, onToggle, visibility}) => (
  <div
    className="playlist-title"
    onClick={e => {
      e.stopPropagation();
      onToggle();
    }}>
    <div className="left">
      <h4>{title}</h4>
    </div>
    <div>
      {visibility === PLAYLIST_VISIBILITY.peek ? (
        <div className="maximize header-icon pointer">
          <Maximize />
        </div>
      ) : (
        <div className="minimize header-icon pointer">
          <Minimize />
        </div>
      )}
      {closable && (
        <div
          onClick={e => {
            e.stopPropagation();
            onHide!();
          }}
          className="close header-icon pointer">
          <Close />
        </div>
      )}
    </div>
  </div>
);

export default PlaylistTitleBar;
